export enum Environment {
  DEVELOPMENT,
  LOCAL,
  PRODUCTION,
}
